// product block bundle -- START
$('.bundle_box').on('click', function() {
  var bundle = $(this).data('bundle');
  var quantity = parseInt(bundle);
  $('.quantity__input').val(quantity);
  
  $('.bundle_box').removeClass('active');
  $(this).addClass('active');
});
// product block bundle -- END


// customer review start

var reviewSlider = $(".customer-review .customer-slider").slick({
  infinite: false,
  dots: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 3,
  centerMode: false,
  centerPadding: '0px',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '20px',
      },
    },
  ],
});
$(".reviews-page-container .reviews-grid_wrap").slick({
  infinite: false,
  dots: false,
  arrows: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
$(document).ready(function () {
    setInterval(function () {
        $(".slick-dots li").removeClass("slick-pn1"); // Remove previous .slick-pn classes
      $(".slick-dots li").removeClass("slick-pn2"); // Remove previous .slick-pn classes

        $(".slick-dots li").each(function () {
            if ($(this).hasClass("slick-active")) {
                let $prev = $(this).prev();
                let $next = $(this).next();

                // Add class to previous and next li
                $prev.addClass("slick-pn1");
                $next.addClass("slick-pn2");

                // If it's the first li, add to next two
                if ($(this).is(":first-child")) {
                    $next.next().addClass("slick-pn1");
                }
              
                // If it's the last li, add class to the previous two
                if ($(this).is(":last-child")) {
                    $prev.prev().addClass("slick-pn2");
                }
            }
        });

        // Show only .slick-active and .slick-pn, hide others
        $(".slick-dots li").each(function () {
            if ($(this).hasClass("slick-active") || $(this).hasClass("slick-pn1") || $(this).hasClass("slick-pn2")) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

    }, 100); // Adjust interval as needed
});


var legthArr = [];
jQuery(document).ready(function () {
  jQuery(".product-solution .product-solution-list").each(function () {
    var height = jQuery(this).outerHeight();
    legthArr.push(height);
  });
  var maxValue = Math.max.apply(Math, legthArr);
  jQuery(".product-solution .product-solution-list").each(function () {
    jQuery(this).css("height", maxValue);
  });
});


// LIFE SLIDER -- START
$(".life__slider").slick({
  infinite: true,
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1
});

$(".life__slider_banner").slick({
  infinite: true,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>'
});

$(document).ready(function () {
  $(".new-video-play-button").click(function () {
    $("body").addClass("video_popup__active");
    let match = $(this).attr("class").match(/popup-id-(\d+)/);
    if (match) {
        let index = match[1];
        $(".popupbox--" + index).fadeIn();
    }
  });
  $(".change-strap-popup-close").click(function () {
    $(this).closest(".change-strap-video-popup").fadeOut();
    $("body").removeClass("video_popup__active");
  });
});

//:: START :: sections/main-product.liquid  ::
$(".product---gallery-v1").find(".product__gallery").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: false,
    infinite: false,
    speed: 200,
    asNavFor: ".product__thumbnail",
    arrows: true,
    dots: false,
    draggable: true,
    focusOnSelect: false,
    prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none"><path d="M29.3711 34.2968L20.4334 25.3591L29.3711 16.4214" stroke="#505050" stroke-width="2.34615" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow: '<button type="button" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="51" height="51" viewBox="0 0 51 51" fill="none"><path d="M21.6289 34.2968L30.5666 25.3591L21.6289 16.4214" stroke="#505050" stroke-width="2.34615" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
});

$(".product---gallery-v1").find(".product__thumbnail").slick({
    slidesToShow: 5.3,
    slidesToScroll: 1,
    asNavFor: ".product__gallery",
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    speed: 200,
    infinite: false,
    arrows: false,
    prevArrow:
      '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    nextArrow:
      '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M11.4641 7L4.46406 14L2.53906 12.1625L7.70156 7L2.53906 1.8375L4.46406 0L11.4641 7Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4.3,
          slidesToScroll: 1
        }
      }
    ]
});

// jQuery(document).on("click", ".zoom-gallery", function () {
//    if(jQuery('.product-media-modal').length>0){
//       jQuery("body").addClass("product-popup-open");
//       jQuery(".product-media-modal").attr("open", "");
//       var $thumbnailSlider = jQuery('.thumbnail-slider');
//       var $modal = jQuery('.product-media-modal');
//       var $modalContent = $modal.find(".product-media-modal__content");
//       if ($thumbnailSlider.find('.product__thumbnail .slider__slide.slick-current.slick-active').length > 0) {
//           var getMediaIndex = $thumbnailSlider.find('.product__thumbnail .slider__slide.slick-current.slick-active').attr('data-slick-index');
//           if (getMediaIndex !== undefined) {
//               var $targetMedia = $modalContent.find('#img_' + parseInt(getMediaIndex));
//               if ($targetMedia.length > 0) {
//                 var targetScroll = Math.round($targetMedia.position().top + $modalContent.scrollTop()+100);  
//                 $modalContent.animate({ scrollTop: targetScroll }, 800);
//               } 
//           }
//       }
//    }
// });

// jQuery(document).on("click", ".product-media-modal__toggle", function () {
//     jQuery("body").removeClass("product-popup-open");
//     jQuery(".product-media-modal").removeAttr("open");
// });

// Close modal on outside click
jQuery(document).on("click", function (event) {
  setTimeout(function(){
    if (jQuery(".product-media-modal.media-modal").attr('open')!="" && jQuery(".product-media-modal.media-modal").attr('open')==undefined) {
      if(jQuery("body").hasClass('product-popup-open')){
        jQuery("body").removeClass("product-popup-open");
      }
    }
  },100);
});

jQuery(document).on("click",".hchoose-modal-button",function(){  
  jQuery('.hchoose-modal').addClass('js-modal-open');
});

jQuery(document).on('click',".hchoose-close",function(){
   jQuery('.hchoose-modal').removeClass('js-modal-open');
});

//:: END :: sections/main-product.liquid  ::

// FAQ -- START
$(document).ready(function() {
  $(".new-set > .question").on("click", function() {
    var $this = $(this);
    var $content = $this.siblings(".new-content");

    if ($this.hasClass("active")) {
      $this.removeClass("active");
      $content.slideUp(200);
    } else {
      $(".new-set > .question").removeClass("active");
      $(".new-content").slideUp(200);

      $this.addClass("active");
      $content.slideDown(200);
    }
  });
});
// FAQ -- END

// KEY BENEFITS -- START
document.addEventListener("DOMContentLoaded", function () {
  const firstAccordionItemHeader = document.querySelector(
    ".kb_accordion-item-header"
  );
  if(firstAccordionItemHeader!=null){
    const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;
  }
  // Open the first accordion item by default
  // firstAccordionItemHeader.classList.add("active");
  // firstAccordionItemBody.style.maxHeight =
  //   firstAccordionItemBody.scrollHeight + "px";

  const accordionItemHeaders = document.querySelectorAll(
    ".kb_accordion-item-header"
  );

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
      const currentlyActiveAccordionItemHeader = document.querySelector(
        ".kb_accordion-item-header.active"
      );
      if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
      ) {
        currentlyActiveAccordionItemHeader.classList.toggle("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight =
          accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
    });
  });
});

// KEY BENEFITS -- END

// MEGAMENU TABING -- START
$(function() {
  $('.megamenu_tabing_labels li').click(function() {
    $('.megamenu_tabing_labels li').removeClass('active');
    $(this).addClass('active');

    let currentTab = $(this).data('target');
    $('.megamenu_products ul').hide();
    $(currentTab).show();

    return false;
  });
});
// MEGAMENU TABING -- END

// PRODUCT STICKY BAR -- START
if(jQuery('.product_buy_buttons').length!=0){
  jQuery(window).scroll(function(){
    var buttonHeight = parseInt(jQuery('.product_buy_buttons').offset().top);
    var compareSectionTop = parseInt(jQuery('.product-faq').offset().top);
    if (jQuery(this).scrollTop() > buttonHeight && jQuery(this).scrollTop() < compareSectionTop) {
        jQuery('.sticky_product_bar').show();
    }else{
        jQuery('.sticky_product_bar').hide();
    }
  });
}
// PRODUCT STICKY BAR -- END

// BEFORE AFTER -- START
function initComparisons() {
  var x, i;
  /*find all elements with an "overlay" class:*/
  x = document.getElementsByClassName("img-comp-overlay");
  for (i = 0; i < x.length; i++) {
    /*once for each "overlay" element:
      pass the "overlay" element as a parameter when executing the compareImages function:*/
    compareImages(x[i]);
  }
  function compareImages(img) {
    var slider,
      img,
      clicked = 0,
      w,
      h;
    /*get the width and height of the img element*/
    w = img.offsetWidth;
    h = img.offsetHeight;
    /*set the width of the img element to 50%:*/
    img.style.width = w / 2 + "px";
    /*create slider:*/
    slider = document.createElement("DIV");
    slider.setAttribute("class", "img-comp-slider");
    /*insert slider*/
    img.parentElement.insertBefore(slider, img);
    /*position the slider in the middle:*/
    slider.style.top = h / 2 - slider.offsetHeight / 2 + "px";
    slider.style.left = w / 2 - slider.offsetWidth / 2 + "px";
    /*execute a function when the mouse button is pressed:*/
    slider.addEventListener("mousedown", slideReady);
    /*and another function when the mouse button is released:*/
    window.addEventListener("mouseup", slideFinish);
    /*or touched (for touch screens:*/
    slider.addEventListener("touchstart", slideReady);
    /*and released (for touch screens:*/
    window.addEventListener("touchend", slideFinish);
    function slideReady(e) {
      /*prevent any other actions that may occur when moving over the image:*/
      e.preventDefault();
      /*the slider is now clicked and ready to move:*/
      clicked = 1;
      /*execute a function when the slider is moved:*/
      window.addEventListener("mousemove", slideMove);
      window.addEventListener("touchmove", slideMove);
    }
    function slideFinish() {
      /*the slider is no longer clicked:*/
      clicked = 0;
    }
    function slideMove(e) {
      var pos;
      /*if the slider is no longer clicked, exit this function:*/
      if (clicked == 0) return false;
      /*get the cursor's x position:*/
      pos = getCursorPos(e);
      /*prevent the slider from being positioned outside the image:*/
      if (pos < 0) pos = 0;
      if (pos > w) pos = w;
      /*execute a function that will resize the overlay image according to the cursor:*/
      slide(pos);
    }
    function getCursorPos(e) {
      var a,
        x = 0;
      e = e.changedTouches ? e.changedTouches[0] : e;
      /*get the x positions of the image:*/
      a = img.getBoundingClientRect();
      /*calculate the cursor's x coordinate, relative to the image:*/
      x = e.pageX - a.left;
      /*consider any page scrolling:*/
      x = x - window.pageXOffset;
      return x;
    }
    function slide(x) {
      /*resize the image:*/
      img.style.width = x + "px";
      /*position the slider:*/
      slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + "px";
    }
  }
}

initComparisons();
jQuery(document).ready(function () {
  var legthArr = [];
  jQuery(".img-comp-container").each(function () {
    var height = jQuery(this).width();
    legthArr.push(height);
  });
  var maxValue = Math.max.apply(Math, legthArr);
  jQuery(".img-comp-img img").each(function () {
    jQuery(this).css("width", maxValue);
  });
});
// BEFORE AFTER -- END

// DOCTOR VIDEO POPUP -- START
jQuery(document).ready(function(){
  jQuery(".tvplay__popup").on("click",function () {
    $(".doctor_video_popup").show();
    $("body").addClass("doctor_video_popup_active");
    if(jQuery('.doctor_video_popup').find('.tv-video').length>0){
      setTimeout(function(){
          var video = jQuery('.doctor_video_popup').find('.tv-video')[0]; // Get the video element
          if (video) {
            video.play();
          }
      },200);
    }
  });
  jQuery(".dv_popup_close").on("click",function () {
    $(".doctor_video_popup").hide();
    $("body").removeClass("doctor_video_popup_active");
    var objthis = jQuery(this);
    if(objthis.parent('div').find('.tv-video').length>0){
      setTimeout(function(){
          var video = objthis.parent('div').find('.tv-video')[0]; // Get the video element
          if (video) {
            video.pause();
          }
      },100);
    }
  });
});
// DOCTOR VIDEO POPUP -- END

// FACETS LAYOUT SWITCH -- START
jQuery(document).ready(function(){
  jQuery(".filter_layout_one").on("click",function () {
    // $(".doctor_video_popup").show();
    $(".collection_product_grid").addClass("product_one_col");
    $(".filter_layout_one").addClass("active");
    $(".filter_layout_two").removeClass("active");
  });
  jQuery(".filter_layout_two").on("click",function () {
    $(".collection_product_grid").removeClass("product_one_col");
    $(".filter_layout_one").removeClass("active");
    $(".filter_layout_two").addClass("active");
  });
});
// FACETS LAYOUT SWITCH -- END

// HOW IT WORKS -- START

$(document).ready(function () {
    // Pehle tab aur column ko active set karna
    $('.fb_tab_title').first().addClass('active');
    $('.feature_block_col').first().addClass('active');
    let featureGrid = document.querySelector(".feature_block_grid");
    $('.fb_tab_title').click(function () {
        // Index find karna
        var index = $(this).index();
        
        // Sabse pehle active class hatao phir click wale pe lagao
        $('.fb_tab_title').removeClass('active');
        $(this).addClass('active');

        // Feature block se bhi active class hatao aur index wale pe lagao
        $('.feature_block_col').removeClass('re-active');
        $('.feature_block_col').eq(index).addClass('re-active');

        if (window.innerWidth <= 768) { // Adjust breakpoint as needed
           featureGrid.scrollTo({
                left: 0,
                behavior: "smooth"
            });
        }
    });
});


// HOW IT WORKS -- END

// HERO SLIDER -- START

$(".hero_banner_slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M20 24L12 16L20 8" stroke="#505050" stroke-width="2" stroke-linecap="square"/></svg></button>',
  nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M12 24L20 16L12 8" stroke="#505050" stroke-width="2" stroke-linecap="square"/></svg></button>',
  asNavFor: ".hero_content_slider"
});
$(".hero_content_slider").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  asNavFor: ".hero_banner_slider",
  arrows: false,
  dots: true,
  focusOnSelect: true
});


// HERO SLIDER -- END

// TABING FAQ -- START
$(document).ready(function () {
    $("ul.faq_tabing li").click(function () {
      var tab_id = $(this).attr("data-tab");
  
      $("ul.faq_tabing li").removeClass("current");
      $(".faq_tab_content").removeClass("current");
  
      $(this).addClass("current");
      $("#" + tab_id).addClass("current");
    });
  });

  $(document).ready(function() {
    $(".frequently-asked-questions .set-question").on("click", function() {
      if ($(this).hasClass("active")) {
          $(this).removeClass("active").siblings(".frequently-asked-questions .new-content").slideUp(200);
      } else {
        $(".frequently-asked-questions .set-question").removeClass("active");
        $(".frequently-asked-questions .new-content").slideUp(200);
        $(this).addClass("active").siblings(".frequently-asked-questions .new-content").slideDown(200);
      }
  });
});
// TABING FAQ -- END

var goalAmount = jQuery('.cc-cart-progress').attr('data-goal-amount');
var goalBeforeText = jQuery('.cc-cart-progress').attr('data-before-amount-text');
var goalAfterText = jQuery('.cc-cart-progress').attr('data-after-amount-text');
var goalReachText = jQuery('.cc-cart-progress').attr('data-goal-reached-text');
setInterval(function(){
  if(jQuery('.cart__drawer.active').length>0){
   jQuery.getJSON('/cart.js', function(cart) {
      let cartData = cart.items;
      let cartstr = '';
      let subTotal = 0;
      var cartCounter=0;
      let totalCart = cartData.length;
      if(cartData.length>0){
        for(var k=0;k<cartData.length;k++){
          var productId = cartData[k].product_id;
          if(jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col[data-col-pid="'+productId+'"]').length>0){
            jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col[data-col-pid="'+productId+'"]').hide();
          }
          //console.log("productId",productId);
          if(jQuery('.cart-drawer .drawer_routine_box').find('.routine_product_col[data-col-pid="'+productId+'"]').length>0){
            jQuery('.cart-drawer .drawer_routine_box').find('.routine_product_col[data-col-pid="'+productId+'"]').hide();
          }
        }
        if(jQuery('.drawer.active').length>0){
          subTotal = cart.original_total_price;
          var percentage_reached = (eval(subTotal) / eval(goalAmount));
          if(parseFloat(percentage_reached) > 100){
            var percentage_reached = 100;
          }
          jQuery('.cc-cart-progress-fill').css("width", Math.round(percentage_reached)+"%");
          jQuery('.cc-cart-progress-fill span').html(Math.round(percentage_reached)+"%");
        
          jQuery('.cc-cart-progressbar').removeClass("progress-filled");
          jQuery('.cart_shipping_box').hide();
          if(percentage_reached == 100){
            jQuery('.cart_shipping_box').show();
            jQuery('.cc-cart-progressbar').addClass("progress-filled");
          }else{
            jQuery('.cart_shipping_box').hide();
          }
          
        
          var cartTotalFull = eval(subTotal) / 100;
          var tempStr = '';
          var svg='<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M5.24016 16.4266C4.63349 16.4266 4.11932 16.2149 3.69766 15.7916C3.27543 15.3677 3.06432 14.853 3.06432 14.2474H1.91016V6.0099C1.91016 5.62656 2.03877 5.30656 2.29599 5.0499C2.55266 4.79267 2.87293 4.66406 3.25682 4.66406H14.2818V7.67656H16.2052L19.0902 11.5549V14.2474H17.7435C17.7435 14.853 17.5313 15.3677 17.1068 15.7916C16.6824 16.2149 16.1668 16.4266 15.5602 16.4266C14.954 16.4266 14.4402 16.2149 14.0185 15.7916C13.5963 15.3677 13.3852 14.853 13.3852 14.2474H7.42349C7.42349 14.8563 7.21127 15.3718 6.78682 15.7941C6.36182 16.2163 5.84627 16.4266 5.24016 16.4266ZM5.24349 15.5941C5.61849 15.5941 5.93682 15.4635 6.19849 15.2024C6.4596 14.9407 6.59016 14.6224 6.59016 14.2474C6.59016 13.8724 6.4596 13.5543 6.19849 13.2932C5.93738 13.0321 5.61905 12.9016 5.24349 12.9016C4.86793 12.9016 4.54988 13.0321 4.28932 13.2932C4.02821 13.5543 3.89766 13.8724 3.89766 14.2474C3.89766 14.6224 4.02821 14.9405 4.28932 15.2016C4.55043 15.4627 4.86849 15.5941 5.24349 15.5941ZM15.5643 15.5932C15.9393 15.5932 16.2574 15.4627 16.5185 15.2016C16.7796 14.9405 16.9102 14.6224 16.9102 14.2474C16.9102 13.8724 16.7796 13.5543 16.5185 13.2932C16.2574 13.0321 15.9393 12.9016 15.5643 12.9016C15.1893 12.9016 14.8713 13.0321 14.6102 13.2932C14.349 13.5543 14.2185 13.8724 14.2185 14.2474C14.2185 14.6224 14.349 14.9405 14.6102 15.2016C14.8713 15.4627 15.1893 15.5932 15.5643 15.5932ZM14.2818 11.7474H18.2085L15.7568 8.5099H14.2818V11.7474Z" fill="#190B41"/></path></svg>';
          if(goalAmount > cartTotalFull){
            var goalPendingAmount = (eval(goalAmount) * 100) - subTotal;
            tempStr += goalBeforeText;
            tempStr += '<span class="cg-goal-amount text-money text-secondary" style="font-weight:bold">';
            tempStr += Shopify.formatMoney(goalPendingAmount);
            tempStr += '</span>'
            tempStr += goalAfterText;
          }
          else{
            tempStr += goalReachText;
            svg = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none"><path d="M10.5625 17.2493V10.7507L4.875 7.45763V13.6533C4.875 13.7431 4.89746 13.8273 4.94238 13.9057C4.98715 13.9843 5.05445 14.0516 5.14428 14.1076L10.5625 17.2493ZM11.4375 17.2493L16.8557 14.1076C16.9456 14.0516 17.0129 13.9843 17.0576 13.9057C17.1025 13.8273 17.125 13.7431 17.125 13.6533V7.45763L11.4375 10.7507V17.2493ZM10.2932 18.1007L4.70678 14.8818C4.4857 14.7551 4.31267 14.5828 4.18769 14.3651C4.06256 14.1475 4 13.9119 4 13.6583V7.3417C4 7.08809 4.06256 6.8525 4.18769 6.63492C4.31267 6.41719 4.4857 6.24496 4.70678 6.11823L10.2932 2.89932C10.5143 2.77259 10.7499 2.70923 11 2.70923C11.2501 2.70923 11.4857 2.77259 11.7068 2.89932L17.2932 6.11823C17.5143 6.24496 17.6873 6.41719 17.8123 6.63492C17.9374 6.8525 18 7.08809 18 7.3417V13.6583C18 13.9119 17.9374 14.1475 17.8123 14.3651C17.6873 14.5828 17.5143 14.7551 17.2932 14.8818L11.7068 18.1007C11.4857 18.2274 11.2501 18.2908 11 18.2908C10.7499 18.2908 10.5143 18.2274 10.2932 18.1007ZM14.2476 8.11564L16.6219 6.74932L11.2693 3.65138C11.1794 3.59538 11.0897 3.56739 11 3.56739C10.9103 3.56739 10.8206 3.59538 10.7307 3.65138L8.6375 4.85451L14.2476 8.11564ZM11 9.99863L13.3625 8.62707L7.74063 5.37798L5.37813 6.74932L11 9.99863Z" fill="#242424"/></svg>';
          }
          jQuery('.cart__goal__message').html(tempStr);
          jQuery('.cc-cart-progress-heading .svg-html').html('');
          jQuery('.cc-cart-progress-heading .svg-html').html(svg);
        }
      }
});
 }
},500);
// END :: CART PROGRESS

// PRODUCT DETAILS PAGE FOR ROUTINE SECTION ADD TO CART CODE START HERE
jQuery(document).on('click','.routine_product_block .routine_add_Cart,.drawer_routine_box .routine_product_btn,.sticky_product_bar .sticky_product_col.sp_col_btn',function(){
  if(jQuery(this).find('.btn_loader_btn').length>0){
    jQuery(this).find('.btn_loader_btn').addClass('show');
  }
  var variantId = jQuery(this).attr('data-vid');
  var productId = jQuery(this).attr('data-pid');
  addToCart(variantId,productId);
});

function addToCart(variantId, productId) {
  if (!variantId) {
    console.error("Error: Missing or invalid variant ID:", variantId);
    return;
  }

  var formData = {
    items: [{ id: variantId, quantity: 1 }],
  };

  //console.log("Attempting to add to cart:", formData);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(formData),
    contentType: "application/json",
    dataType: "json",
    success: function (response) {
      //console.log("Added to cart successfully:", response);
      customdrawerOpen(productId);
    },
    error: function (xhr, status, error) {
      console.error("Error adding to cart:", xhr.responseText);
      // Fallback: Try using form-encoded data if JSON fails
      var fallbackFormData = new FormData();
      fallbackFormData.append("id", variantId);
      fallbackFormData.append("quantity", 1);

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: fallbackFormData,
        processData: false,
        contentType: false,
        success: function (response) {
          //console.log("Fallback method: Added to cart successfully", response);
          customdrawerOpen(productId);
        },
        error: function (xhr, status, error) {
          //console.error("Fallback method also failed:", xhr.responseText);
        },
      });
    },
  });
}


jQuery(document).ready(function(){
  var upsellInter = setInterval(function(){
    if(jQuery('.cart-drawer').find('.drawer_routine_box').length>0 || jQuery('.product__info-wrapper .routine_product_block').length>0){
      upsellProductHideShow();
    }
  },10);
});

function customdrawerOpen(productid){
  if(jQuery('.product__info-wrapper .routine_product_block').find('[data-col-pid="'+productid+'"]').length>0){
    jQuery('.product__info-wrapper .routine_product_block').find('[data-col-pid="'+productid+'"]').hide();
  }
  if(jQuery('.cart-drawer .drawer_routine_box').find('.routine_product_col[data-col-pid="'+productid+'"]').length>0){
    jQuery('.cart-drawer .drawer_routine_box').find('.routine_product_col[data-col-pid="'+productid+'"]').hide();
  }
  
  upsellProductHideShow();
  var cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.remove('is-empty');
    $.ajax({
      url: "/?sections=cart-drawer,cart-icon-bubble",
      type: "GET",
      dataType: "json",
      success: function (parsedState) {
        if (!parsedState || !parsedState["cart-drawer"]) {
          console.error("Error: cart-drawer section not found", parsedState);
          return;
        }
        cartDrawer.renderContents({
          sections: {
            "cart-drawer": parsedState["cart-drawer"],
            "cart-icon-bubble": parsedState["cart-icon-bubble"],
          },
        });
        jQuery('.btn_loader_btn').removeClass('show');
      }
    });
  }
}

jQuery(document).on('click','.drawer__cart-items-wrapper .cart-remove-button',function(){
  var quantity = jQuery(this).parent().parent().find('.quantity__input').attr('data-cart-quantity');
  var productId = jQuery(this).attr('data-pcart-id');
  setTimeout(function(){
    if(jQuery('.product__info-wrapper .routine_product_block').find('[data-col-pid="'+productId+'"]').length>0){
      jQuery('.product__info-wrapper .routine_product_block').find('[data-col-pid="'+productId+'"]').show();
    }
  },1000);
});

function upsellProductHideShow(){
  if(jQuery('.cart-drawer').find('.cart-items .cart-item').length>0 && jQuery('.drawer_routine_box').find('.routine_product_col').length>0){
    var totalUpsellCount = parseInt(jQuery('#drawer_product_count').val());
    var totalUpsellVisibleCount = 0;
    jQuery('.drawer_routine_box').find('.routine_product_col').each(function() {
      if(jQuery(this).css('display')=='none'){
         totalUpsellVisibleCount++;
      }
    });
    if(totalUpsellCount==totalUpsellVisibleCount){
      jQuery('.cart-drawer').find('.drawer_routine_box').hide();
    }else{
      jQuery('.cart-drawer').find('.drawer_routine_box').show();
    }
  }
  if(jQuery('.cart-drawer').find('.cart-items .cart-item').length>0 && jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col').length>0){
    var totalUpsellCount = parseInt(jQuery('#collect_product_count').val());
    var totalUpsellVisibleCount = 0;
    jQuery('.product__info-wrapper .routine_product_block').find('.routine_product_col').each(function() {
      if(jQuery(this).css('display')=='none'){
         totalUpsellVisibleCount++;
      }
    });
    if(totalUpsellCount==totalUpsellVisibleCount){
      jQuery('.product__info-wrapper .routine_product_block').hide();
    }else{
      jQuery('.product__info-wrapper .routine_product_block').show();
    }
  }
}
// PRODUCT DETAILS PAGE FOR ROUTINE SECTION ADD TO CART CODE END HERE

// VIDEO AUTO PLAY FOR BANNER HOME SECTION START HERE
// jQuery(document).ready(function(){
//   var videoInter = setInterval(function(){
//     if(jQuery('.hero_banner_section').find('.hb_video_box').length>0){
//       let video = jQuery("#hero-banner-video")[0];
//       video.muted = true;
//       video.play();
//       jQuery('.tplay-icon').trigger("click");
//     }
//   },100);
// })
// VIDEO AUTO PLAY FOR BANNER HOME SECTION END HERE


$(document).ready(function () {
  if($(window).width() < 768){
    function updateActiveTab() {
      let scrollLeft = $('.feature_block_grid').scrollLeft();
      let containerWidth = $('.feature_block_grid').width();
      let closestIndex = 0;
      let minDistance = Infinity;
  
      $('.feature_block_col').each(function (index) {
        let offsetLeft = $(this).position().left;
        let distance = Math.abs(offsetLeft);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });
  
      // Set active class on the matching tab
      $('.fb_tab_title').removeClass('active');
      $('.fb_tab_title').eq(closestIndex).addClass('active');
    }
  
    // Run on scroll
    $('.feature_block_grid').on('scroll', function () {
      updateActiveTab();
    });
  }

  // Run on page load
  //updateActiveTab();
});

// product gallery + zoom + fancybox -- START

Fancybox.bind("[data-fancybox]", {
  // Your custom options...

  on: {
    reveal: (fancybox, slide) => {
      // Wait for image to be in DOM
      $('.fancybox__content img').each(function () {
        const $img = $(this);

        // Avoid double-wrapping
        if (!$img.parent().hasClass('zoom-container')) {
          $img.wrap('<div class="zoom-container"></div>');
        }

        // Destroy any existing zoom and re-initialize
        $img.parent().trigger('zoom.destroy').zoom();
      });
    }
  }
});

$(document).ready(function(){
  $('.zoom-container').zoom();
});
//

jQuery(document).on("click", ".product__media-wrapper .zoom-gallery", function () {
  const $currentSlide = jQuery('.product--media-item.grid__item.slick-current.slick-active');
  const $fancyboxLink = $currentSlide.find('a.fancybox-href');
  if ($fancyboxLink.length > 0) {
    $fancyboxLink[0].click();
    setTimeout(function(){
      $('.fancybox__content img').parent().zoom();
    },1000);
  }
});

// product gallery + zoom + fancybox -- END

    const allButtons = document.querySelectorAll('[id^="Deferred-Poster-Modal-"]');
    
    allButtons.forEach(playButton => {
        playButton.addEventListener('click', function() {
            const deferredMedia = playButton.closest('deferred-media');
            
            if (deferredMedia) {
                const template = deferredMedia.querySelector('template');
                
                if (template) {
                    const video = template.content.querySelector('video');
                    
                    if (video) {
                        const content = template.content.cloneNode(true);
                        const clonedVideo = content.querySelector('video');
                        
                        clonedVideo.muted = false;
                        clonedVideo.volume = 1.0;
                        
                        template.parentNode.replaceChild(content, template);
                        
                        const activeVideo = deferredMedia.querySelector('video');
                        if (activeVideo) {
                            const buttonId = playButton.id;
                            const videoNumber = buttonId.replace('Deferred-Poster-Modal-', '');
                            const duplicateVideo = document.querySelector('#myvideo-' + videoNumber + ' + #myvideo-' + videoNumber);
                            if (duplicateVideo) {
                                duplicateVideo.remove();
                            }
                            
                            activeVideo.play();
                        }
                    }
                }
            }
        });
    });


//   $(".quick-add-modal .product__media-list").slick({
//         infinite: false,
//         dots: false,
//         arrows: true,
//         slidesToShow: 2,
//         slidesToScroll: 1,
//         responsive: [
//           {
//             breakpoint: 1025,
//             settings: {
//               slidesToShow: 2,
//               slidesToScroll: 1,
//             },
//           },
//           {
//             breakpoint: 575,
//             settings: {
//               slidesToShow: 1,
//               slidesToScroll: 1,
//             },
//           },
//         ],
// });



// $(".quick-add-modal .product__thumbnail").slick({
//     infinite: false,
//     dots: false,
//     arrows: true,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     responsive: [
//       {
//         breakpoint: 1025,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 575,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//         },
//       },
//     ],
// });


document.addEventListener('click', function (e) {
  if (!e.target.closest('.quick-add-modal__toggle')) return;

  console.log('It is clicked');


});